// WordPress dependencies.
// @ts-nocheck
import { useState, useEffect } from "@wordpress/element";
import { Notice } from "@wordpress/components";
import { Icon, image, trash, video } from "@wordpress/icons";
import { __ } from "@wordpress/i18n";

const coreAssets = window.COCA_BAIS_ASSETS;
console.log('Core Assets:', coreAssets);
if (coreAssets && coreAssets.placeholder_video) {
    console.log('Video Placeholder:', coreAssets.placeholder_video.placeholder_video);
}
if (coreAssets && coreAssets.placeholder_image) {
    console.log('Image Placeholder:', coreAssets.placeholder_image.placeholder_image);
}

export default function (props) {
    const [uploadOptions, setUploadOptions] = useState({});
    const [mediaFrame, setMediaFrame] = useState(null);
    const mediaType = props.mediaType || "image"; // Default to image if not specified
    const isProFeature = !!props.isProFeature;
    const proFeatureEnabled = props.proFeatureEnabled;

    // Reset frame when component unmounts
    useEffect(() => {
        return () => {
            if (mediaFrame) {
                mediaFrame.off("select");
            }
        };
    }, [mediaFrame]);

    function isImage(url) {
        return url && /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    }

    function isVideo(url) {
        return url && /\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv)$/.test(url);
    }

    function isValidMedia(url) {
        if (mediaType === "image") {
            return isImage(url);
        } else if (mediaType === "video") {
            return isVideo(url);
        } else {
            // For 'both' type
            return isImage(url) || isVideo(url);
        }
    }

    const uploadMedia = (event) => {
        event.preventDefault();

        // Don't open media frame if clicking on remove icon
        if (event.target.closest(".remove-icon")) {
            return;
        }

        // Determine library type based on mediaType prop
        let libraryType = "image";
        if (mediaType === "video") {
            libraryType = "video";
        } else if (mediaType === "both") {
            libraryType = ["image", "video"];
        }

        // Set appropriate title and button text
        let title = __("Select or Upload an image", "wp-before-after-image-slider-pro");
        let buttonText = __("Select Image", "wp-before-after-image-slider-pro");

        if (mediaType === "video") {
            title = __("Select or Upload a video", "wp-before-after-image-slider-pro");
            buttonText = __("Select Video", "wp-before-after-image-slider-pro");
        } else if (mediaType === "both") {
            title = __("Select or Upload media", "wp-before-after-image-slider-pro");
            buttonText = __("Select Media", "wp-before-after-image-slider-pro");
        }

        // Create a new media frame
        const frame = window.wp.media({
            title: title,
            button: { text: buttonText },
            library: { type: libraryType },
            multiple: false,
        });

        // Fire select event on user activity
        frame.on("select", function () {
            const attachment = frame.state().get("selection").first().toJSON();

            // Check if attachment is valid based on mediaType
            let isValid = false;

            if (mediaType === "image") {
                isValid = attachment.mime && attachment.mime.startsWith("image/");
            } else if (mediaType === "video") {
                isValid = attachment.mime && attachment.mime.startsWith("video/");
            } else {
                // 'both'
                isValid =
                    attachment.mime && (attachment.mime.startsWith("image/") || attachment.mime.startsWith("video/"));
            }

            if (props.onChange && attachment.url && isValid) {
                // Call onChange with the selected attachment
                props.onChange(attachment);
                setUploadOptions({
                    attachment,
                    invalidMedia: false,
                    noticeClose: false,
                });
            } else {
                setUploadOptions({
                    attachment,
                    invalidMedia: true,
                    noticeClose: false,
                });
            }
        });

        // Open the modal
        frame.open();

        // Store the frame reference
        setMediaFrame(frame);
    };

    const onRemoveMedia = (event) => {
        event.preventDefault();
        event.stopPropagation(); // Prevent event from bubbling up

        if (props.onChange) {
            props.onChange(null);
        }
    };

    // Placeholder image styles.
    const MediaStyles = {
        margin: "0 auto",
        width: "100%",
        height: "60%",
        verticalAlign: "middle",
        marginTop: "10px",
    };

    const viewMedia = () => {
        // Render broken uploader placeholder to preview panel.
        if (uploadOptions.invalidMedia || (props.value && !isValidMedia(props.value.url))) {
            return mediaType === "video" ? (
                <Icon icon={video} className={"placeholder-broken-media"} style={MediaStyles} />
            ) : (
                <Icon icon={image} className={"placeholder-broken-image"} style={MediaStyles} />
            );
        }

        // Render uploaded image to preview panel.
        if (props.value && props.value.url) {
            if (isImage(props.value.url)) {
                const imageSrcUrl =
                    props.value.sizes && props.value.sizes.thumbnail
                        ? props.value.sizes.thumbnail.url
                        : props.value.url;
                return <img src={imageSrcUrl} alt={props.value.alt || ""} />;
            } else if (isVideo(props.value.url)) {
                // For videos, show thumbnail if available, otherwise show video icon with filename
                if (props.value.image && props.value.image.src) {
                    return (
                        <div className="video-preview">
                            <video src={props.value.url} />
                            {/* <div className="video-icon-overlay">
                                <Icon icon={video} />
                            </div> */}
                        </div>
                    );
                } else {
                    return (
                        <div className="video-preview">
                            {coreAssets && coreAssets.placeholder_video && coreAssets.placeholder_video.placeholder_video ? (
                                <img 
                                    src={coreAssets.placeholder_video.placeholder_video} 
                                    className="placeholder-video" 
                                    alt="Video Preview" 
                                    style={MediaStyles} 
                                />
                            ) : (
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="placeholder-video" aria-hidden="true" focusable="false" style={MediaStyles}>
                                    <path d="M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"></path>
                                </svg>
                            )}
                            <div className="video-filename">{props.value.filename}</div>
                        </div>
                    );
                }
            }
        }

        // Render uploader placeholder to preview panel.
        return mediaType === "video" ? (
            // Try to use the placeholder video from global assets, fall back to inline SVG
            coreAssets && coreAssets.placeholder_video && coreAssets.placeholder_video.placeholder_video ? (
                <img 
                    src={coreAssets.placeholder_video.placeholder_video} 
                    className="placeholder-upload-video" 
                    alt="Upload Video" 
                    style={MediaStyles} 
                />
            ) : (
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="placeholder-upload-video" aria-hidden="true" focusable="false" style={MediaStyles}>
                    <path d="M18.7 3H5.3C4 3 3 4 3 5.3v13.4C3 20 4 21 5.3 21h13.4c1.3 0 2.3-1 2.3-2.3V5.3C21 4 20 3 18.7 3zm.8 15.7c0 .4-.4.8-.8.8H5.3c-.4 0-.8-.4-.8-.8V5.3c0-.4.4-.8.8-.8h13.4c.4 0 .8.4.8.8v13.4zM10 15l5-3-5-3v6z"></path>
                </svg>
            )
        ) : (
            // Try to use the placeholder image from global assets, fall back to inline SVG
            coreAssets && coreAssets.placeholder_image && coreAssets.placeholder_image.placeholder_image ? (
                <img 
                    src={coreAssets.placeholder_image.placeholder_image} 
                    className="placeholder-upload-image" 
                    alt="Upload Image" 
                    style={MediaStyles} 
                />
            ) : (
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24" className="placeholder-upload-image" aria-hidden="true" focusable="false" style={MediaStyles}>
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.5h14c.3 0 .5.2.5.5v8.4l-3-2.9c-.3-.3-.8-.3-1 0L11.9 14 9 12c-.3-.2-.6-.2-.8 0l-3.6 2.6V5c-.1-.3.1-.5.4-.5zm14 15H5c-.3 0-.5-.2-.5-.5v-2.4l4.1-3 3 1.9c.3.2.7.2.9-.1L16 12l3.5 3.4V19c0 .3-.2.5-.5.5z"></path>
                </svg>
            )
        );
    };

    // Determine the footer text based on media type
    const getFooterText = () => {
        if (mediaType === "video") {
            return props?.value?.id
                ? __("Change video", "wp-before-after-image-slider-pro")
                : __("Choose a video", "wp-before-after-image-slider-pro");
        } else if (mediaType === "both") {
            return __("Choose media", "wp-before-after-image-slider-pro");
        } else {
            return props?.value?.id
                ? __("Change image", "wp-before-after-image-slider-pro")
                : __("Choose an image", "wp-before-after-image-slider-pro");
        }
    };

    // Get error message based on media type
    const getErrorMessage = () => {
        const fileType = uploadOptions.attachment?.mime || "unknown";

        if (mediaType === "video") {
            return `Please select a video file. Supported video files are mp4 & webm.`;
        } else if (mediaType === "both") {
            return `Filetype ${fileType} is not supported. Please select an Image or Video file.`;
        } else {
            return `Filetype ${fileType} is not supported for Image Slider. Please select an Image file.`;
        }
    };

    return (
        <div className={"coca-upload-media__component"}>
            <div className={"coca-upload-media"} onClick={uploadMedia}>
                {!uploadOptions.invalidMedia && props.value && props.value.url && isValidMedia(props.value.url) && (
                    <a
                        className={"remove-icon"}
                        href={"#"}
                        onClick={onRemoveMedia}
                        aria-label={__("Remove media", "wp-before-after-image-slider-pro")}
                    >
                        <Icon icon={trash} />
                    </a>
                )}
                {viewMedia()}
                <div className={"overlay"}>
                    <div className="footer">{getFooterText()}</div>
                </div>

                {isProFeature && proFeatureEnabled === false ? (
                    <img className="picker-item__premium" src={coreAssets.icons.premium} alt="Premium Icon" />
                ) : null}
            </div>
            {(uploadOptions.invalidMedia || (props.value && !isValidMedia(props.value.url))) &&
                !uploadOptions.noticeClose && (
                    <Notice
                        status="error"
                        politeness="assertive"
                        onRemove={() => setUploadOptions((prevState) => ({ ...prevState, noticeClose: true }))}
                        spokenMessage={getErrorMessage()}
                        isDismissible={false}
                        status="assertive"
                    >
                        {getErrorMessage()}
                    </Notice>
                )}
        </div>
    );
}
